import { Button, Col, FormGroup, Label, Row, Table } from "reactstrap";
import "./styles.css";
import DatePicker from "react-datepicker";
import { ptBR } from "date-fns/locale";
import { useContext, useState } from "react";
import { Context } from "../../../../hooks/useAuthContext";
import api from "../../../../services/axiosConfig";
import { formatarMoedaDolar } from "../../../../utils/formatMoeda";
import { toast } from "react-toastify";
import { format } from "date-fns";

function TaxaPlataforma() {
  const { exibirLogs } = useContext(Context);
  const [taxas, setTaxas] = useState([]);
  const [foiBuscado, setFoiBuscado] = useState(false);
  const [mesAno, setMesAno] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalTaxaPlataforma, setTotalTaxaPlataforma] = useState();
  const [totalReceitaBruta, setTotalReceitaBruta] = useState();
  const [totalReceitaLiquida, setTotalReceitaLiquida] = useState();

  async function fetchData() {
    try {
      setLoading(true);
      setFoiBuscado(true);

      const dataFormatada = format(mesAno, 'MM/yyyy');

      const response = await api.post("users/dashboard/taxa-receita", { params: {
        date: dataFormatada,
      }});

      setTaxas(response.data.relatorio);
      setTotalTaxaPlataforma(response.data.totalTaxaPlataforma);
      setTotalReceitaBruta(response.data.totalReceitaBruta);
      setTotalReceitaLiquida(response.data.totalReceitaLiquida);

    } catch (error) {
      exibirLogs && console.error("Erro ao buscar solicitações:", error);
      toast.error(error.response?.data?.error)
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="containerTax">
      <h2 className="titleTax">Análise de informações</h2>
      <Row>
        <Col md={3} sm={6} xs={12}>
          <FormGroup className="filterGroup">
            <Label for="mesAno">Mês e Ano:</Label>
            <DatePicker
              selected={mesAno}
              onChange={(date) => setMesAno(date)}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              locale={ptBR}
              className="dateInputRelatorio form-control"
              placeholderText="Selecione mês e ano"
              id="mesAno"
              autoComplete="off"
            />
            <span style={{ color: 'red', fontSize: 14 }}>Data referente ao mês da receita (2M atrás)</span>
          </FormGroup>
        </Col>

        <Col md={3} sm={6} xs={12}>
          <FormGroup className="filterGroup">
            <Label>Ação</Label>
            <Button color="primary" block onClick={fetchData}>
              Buscar
            </Button>
          </FormGroup>
        </Col>
      </Row>

      <div>
        {foiBuscado && !loading && taxas.length > 0 && (
          <strong style={{ fontSize: 20 }}>Receitas</strong>
        )}
      </div>

      <Table striped>
        <thead>
          <tr>
            <th>Nome</th>
            <th>
              Receita Bruta{" "}
              <span className="text-muted" style={{ fontSize: 14 }}>
                ($ {formatarMoedaDolar(totalReceitaBruta)})
              </span>
            </th>
            <th>
              Receita Líquida{" "}
              <span className="text-muted" style={{ fontSize: 14 }}>
                ($ {formatarMoedaDolar(totalReceitaLiquida)})
              </span>
            </th>
            <th>
              Taxa da plataforma{" "}
              <span className="text-muted" style={{ fontSize: 14 }}>
                ($ {formatarMoedaDolar(totalTaxaPlataforma)})
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {!foiBuscado ? (
            <tr>
              <td colSpan="4" className="text-center">
                Nenhuma busca realizada ainda.
              </td>
            </tr>
          ) : loading ? (
            <tr>
              <td colSpan="4" className="text-center">
                Carregando...
              </td>
            </tr>
          ) : taxas.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center">
                Nenhum resultado encontrado.
              </td>
            </tr>
          ) : (
            taxas.map((item, index) => (
              <tr key={index}>
                <td>{item.nome}</td>
                <td>$ {formatarMoedaDolar(item.receitaBruta)}</td>
                <td>$ {formatarMoedaDolar(item.receitaLiquida)}</td>
                <td>$ {formatarMoedaDolar(item.taxaPlataforma)}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}

export default TaxaPlataforma;
